import type { FaireProductEntity } from "../../entity_types/product";

export const p_bvejzx5ek7: FaireProductEntity = {
  token: "p_bvejzx5ek7",
  type: "product",
  name: "Ravens, Black Calcite - Set of 10 Pieces",
  brandToken: "b_52zr2whq85",
  brandName: "Jensen Rocks",
  imageUrl:
    "https://cdn.faire.com/fastly/90c13f8051fa659ae475e35fe16ae47190af247bbfb4b40366ead263387150d3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8990277bf56d02a361a2f52c0f7dcbf6e351554b1d8fae0d34934f7e7f03d57a.png",
  ],
  priceDollars: 55.43,
  description:
    "Our Black Calcite Ravens are approximately 2 inches high. They are a BEST SELLER.\n\nPhotos accurately represent the product you will receive.\nSlight variations in color, size and natural formation are to be expected.\n\nSold in a pack of 10",
  tags: [],
  msrpDollars: 110.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:38.766Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
